import FlaggedIcon from "../../../../../../../assets/svg/flagged-icon";
import InfoBtnIcon from "../../../../../../../assets/svg/info-btn-icon";
import { getHelpdeskLabels } from "../../../../../../../utils/constants/mappings";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../../redux/store";
import { PRIORITIES } from "../utils/constants";
import type { PrioritySelectorProps } from "../utils/types";

const PrioritySelector = ({
  value,
  onChange,
  error,
}: PrioritySelectorProps) => {
  const region = useSelector(
    (state: RootState) => state?.auth?.client?.region
  );
  const helpdeskLabels = getHelpdeskLabels(region ?? "UK");
  return (
    <div className="flex flex-col gap-1.5" data-form-field="priority">
      <span className="text-md font-medium text-heading-text dark:text-heading-text-dk">
        Priority
      </span>
      <div className="flex items-stretch gap-3">
        {PRIORITIES?.map((priority) => {
          const isSelected = value === priority.value;
          return (
            <button
              key={priority.value}
              type="button"
              onClick={() => onChange(priority.value)}
              className={`flex flex-col items-start gap-1.5 flex-1 p-3 rounded-[8px] border transition-colors cursor-pointer ${
                isSelected
                  ? priority.selectedBorderClass
                  : "border-border-gray dark:border-border-gray-dk bg-pure-white dark:bg-pure-white-dk hover:bg-hover-effect dark:hover:bg-hover-effect-dk"
              }`}
            >
              <div className="flex gap-1">
                <FlaggedIcon
                  className={`w-[14px] h-[14px] shrink-0 mt-0.5 ${priority.flagClass}`}
                />
                <span className="text-md font-medium text-verba-indigo dark:text-verba-indigo-dk">
                  {priority.label}
                </span>
              </div>

              <span className="text-xs text-data dark:text-data-dk">
                {priority.sla}
              </span>
            </button>
          );
        })}
      </div>
      <div className="flex items-center gap-1">
        <InfoBtnIcon className="w-[14px] h-[14px] text-gray-placeholder dark:text-gray-placeholder-dk shrink-0" />
        <span className="text-xs text-dark-gray dark:text-dark-gray-dk">
          SLA Period to start once {helpdeskLabels.ticketSingularLower} has been raised
        </span>
      </div>
      {error && (
        <span className="text-xs text-verba-red-alert dark:text-verba-red-alert-dk">
          {error}
        </span>
      )}
    </div>
  );
};

export default PrioritySelector;
